<template>
	<p class="wave">
		<span class="wave__item"></span>
	</p>
</template>
<script setup>

</script>
<style lang="scss">
@import './wave.scss';
</style>
